import { useState } from "react";

import { Box, Divider, Pagination } from "@mui/material";
import { useParams } from "react-router-dom";

import { CompactSupplierShipmentPreview } from "../SupplierShipmentPreview/CompactSupplierShipmentPreview";

interface Props {
  supplierShipments: SupplierShipment[];
  shipmentSelectionIsDisabled: boolean;
  handlePageSelected: (e: React.ChangeEvent<unknown>, value: number) => void;
  page: number;
  pages: number;
}

export function QuickSupplierShipmentsBrowser(props: Props) {
  const params = useParams();
  const shipmentId = params.id;
  const {
    supplierShipments,
    shipmentSelectionIsDisabled,
    handlePageSelected,
    page,
    pages,
  } = props;
  const [selected, setSelected] = useState<number | undefined>(
    shipmentId ? +shipmentId : undefined,
  );

  return (
    <Box boxShadow={1}>
      {supplierShipments.map((s, i) => (
        <Box key={s.info.id}>
          {i > 0 && <Divider />}
          <CompactSupplierShipmentPreview
            supplierShipment={s}
            selected={s.info.id === selected}
            onShipmentSelected={setSelected}
            selectionIsDisabled={shipmentSelectionIsDisabled}
          />
        </Box>
      ))}
      <Divider />
      <Box my="1rem" display="flex" alignItems="center" justifyContent="center">
        <Pagination count={pages} onChange={handlePageSelected} page={page} />
      </Box>
    </Box>
  );
}
